import { NgOptimizedImage } from "@angular/common";
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { HeaderScrollService } from "@core/services/utils/header-scroll.service";
import { TranslatePipe } from "@ngx-translate/core";
import { BEBasicService } from "@services/be-basic.service";
import { Subject, takeUntil } from "rxjs";
import { UserButtonComponent } from "../../components/profile/user-button/user-button.component";
import { HeaderIconsComponent } from "./header-icons/header-icons.component";
import { NotificationEvent } from "./header-icons/notifications-panel/notification-item/types";

@Component({
  selector: "app-lc-header",
  templateUrl: "./lc-header.component.html",
  styleUrl: "./lc-header.component.scss",
  imports: [
    RouterLink,
    UserButtonComponent,
    HeaderIconsComponent,
    TranslatePipe,
    NgOptimizedImage,
  ],
})
export class LcHeaderComponent implements OnInit, OnDestroy {
  protected apiService = inject(BEBasicService);
  private headerScrollService = inject(HeaderScrollService);

  @Input() public newMessages = false;
  @Input() public notifications: NotificationEvent[] = [];
  @Input() public userName = "-";
  @Input() public userSurname = "-";
  @Output() public markNotificationAsReadEvent =
    new EventEmitter<NotificationEvent>();

  private readonly destroy$ = new Subject<void>();

  protected isUserLoggedIn = false;
  protected isScrolled = false;

  ngOnInit(): void {
    this.apiService
      .isUserLoggedIn$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLogged => {
        this.isUserLoggedIn = isLogged;
      });
  }

  @HostListener("window:scroll", [])
  onWindowScroll(): void {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.isScrolled = scrollTop > 0;
    this.headerScrollService.setScrolled(this.isScrolled);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected get hasNotifications(): boolean {
    return this.notifications?.length > 0;
  }

  markNotificationAsRead(notification: NotificationEvent): void {
    this.markNotificationAsReadEvent.emit(notification);
  }
}
